import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, orangeMui } from "@ryde/theme";

import { REBUILD_ROUTE_PROVIDER_INDICATORS_E2E } from "./rebuild-route-dropdown.constants";

export const RebuildRouteProviderIndicatorsStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: REBUILD_ROUTE_PROVIDER_INDICATORS_E2E,
  },
)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-inline-start: 6px;
  vertical-align: middle;

  .rebuild-route-provider-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.02em;
    padding: 2px 7px;
    white-space: nowrap;
  }

  .rebuild-route-provider-indicator--last-used {
    color: ${orangeMui._800};
    background-color: ${orangeMui._50};
    border: 1px solid ${orangeMui._200};
  }

  .rebuild-route-provider-indicator--system-default {
    color: ${blueMui._800};
    background-color: ${blueMui._50};
    border: 1px solid ${blueMui._200};
  }
`;
